import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M24.1.32c.634-.426 1.374-.426 1.904 0 9.416 7.231 18.514 8.19 18.62 8.19.74.105 1.376.745 1.376 1.597v18.508c0 9.895-18.198 20-20.314 21.17-.212.108-.528.213-.74.213-.212 0-.528-.105-.74-.214C22.196 48.615 4 38.298 4 28.615V10.108c0-.851.634-1.491 1.374-1.595.106 0 9.204-1.067 18.726-8.193"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FFF",
    d: "M30.176 27.277l4.216 1.632c-.658 2.944-1.752 5.094-3.284 6.452-1.53 1.358-3.414 2.038-5.652 2.038-2.81 0-5.09-1.084-6.836-3.248-2.01-2.5-3.014-5.874-3.014-10.122 0-4.484 1.01-7.996 3.034-10.532 1.762-2.2 4.124-3.302 7.094-3.302 2.42 0 4.444.826 6.07 2.476 1.162 1.172 2.014 2.912 2.552 5.222L30.05 19.15c-.276-1.424-.826-2.516-1.644-3.276-.824-.76-1.79-1.14-2.904-1.14-1.594 0-2.896.694-3.9 2.082-1.008 1.388-1.51 3.678-1.51 6.872 0 3.312.49 5.67 1.47 7.07.982 1.398 2.256 2.098 3.822 2.098 1.15 0 2.142-.446 2.98-1.336.836-.89 1.44-2.306 1.812-4.244"
  })]
});